import React, { FC, useEffect, useRef } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { color } from "Configs/theme";
import OrganizationsPage from "Components/Organization/OrganizationsPage";
import { useUserStateStore } from "Components/UserState/UserStateStore";
import ErrorView from "./ErrorView";
import LoadingIndicator from "./LoadingIndicator";
import { useViewer } from "Components/Auth/AuthProvider";
import { isSaveDocumentStore } from "Helpers/StoreHelper";

const AppView: FC = () => {
  const viewer = useViewer();
  const classes = useStyles();
  const viewerUserStateStore = useUserStateStore(viewer.user.uid);
  const viewerUserStateStoreRef = useRef(viewerUserStateStore);

  // TODO: move viewer user state to auth provider!
  useEffect(() => {
    if (viewerUserStateStore.errorType === "notExist") {
      viewerUserStateStoreRef.current.setItem(
        {
          userId: viewer.user.uid,
          organizationsAdded: [],
          unreadChannels: [],
        },
        viewer.user.uid
      );
    }
  }, [viewerUserStateStore.errorType, viewer.user.uid]);

  if (
    viewerUserStateStore.isLoading ||
    viewerUserStateStore.errorType === "notExist"
  ) {
    return <LoadingIndicator />;
  } else if (viewerUserStateStore.error) {
    return <ErrorView error={viewerUserStateStore.error} />;
  } else if (isSaveDocumentStore(viewerUserStateStore)) {
    return (
      <Box className={classes.root}>
        <OrganizationsPage viewerUserStateStore={viewerUserStateStore} />
      </Box>
    );
  } else {
    return <ErrorView error={new Error("Missing viewer user state")} />;
  }
};

export default AppView;

const useStyles = makeStyles({
  root: {
    display: "flex",
    flex: 1,
    backgroundColor: color.background,
  },
});
